export class AssignVenuesEmployeeModel {
  public employeeId: string;
  public venueIds: Array<string>;
}
